export const WARDYA_DOCS_URL = (import.meta.env.VITE_WARDYA_DOCS_URL ?? 'https://docs.wardya.ai').replace(/\/$/, '');

export function docsHref(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${WARDYA_DOCS_URL}${normalizedPath}`;
}

export const docsSections = [
  {
    title: 'Overview',
    description: 'Platform positioning, deployment models, and core capabilities for buyer and technical audiences.',
    path: '/docs/overview/intro',
  },
  {
    title: 'Getting Started',
    description: 'Quick start, configuration, first API call, and first verification workflow.',
    path: '/docs/getting-started/quick-start',
  },
  {
    title: 'Products',
    description: 'Identity verification, AML screening, and case management product documentation.',
    path: '/docs/products/identity-verification',
  },
  {
    title: 'API Reference',
    description: 'Authentication, conventions, webhooks, and service-specific API guidance.',
    path: '/docs/api/auth',
  },
  {
    title: 'Integrations',
    description: 'Fayda, webhook, banking, and partner integration patterns.',
    path: '/docs/integrations/fayda',
  },
  {
    title: 'Architecture',
    description: 'System overview, data flow, security architecture, and platform composition.',
    path: '/docs/architecture/system-overview',
  },
  {
    title: 'Security & Compliance',
    description: 'Security posture, privacy, governance, and regulated operating controls.',
    path: '/docs/security-compliance/security-overview',
  },
  {
    title: 'Deployment',
    description: 'Docker, environment variables, and secure runtime deployment guidance.',
    path: '/docs/deployment/azure',
  },
  {
    title: 'Operations',
    description: 'Admin guide, tenant onboarding, and operational runbook entry points.',
    path: '/docs/operations/admin-guide',
  },
  {
    title: 'Tutorials',
    description: 'End-to-end examples such as building a KYC flow.',
    path: '/docs/tutorials/build-a-kyc-flow',
  },
  {
    title: 'Release Notes',
    description: 'Track documentation and platform changes over time.',
    path: '/docs/release-notes/changelog',
  },
];

export const featuredDocs = [
  {
    title: 'API Authentication',
    description: 'How credentials, environment separation, and authenticated requests work in Wardya.',
    path: '/docs/api/auth',
    category: 'API reference',
  },
  {
    title: 'API Errors',
    description: 'Structured failure handling, retry guidance, and request tracing expectations.',
    path: '/docs/api/errors',
    category: 'API reference',
  },
  {
    title: 'Webhooks',
    description: 'Event delivery, signature validation, retry behavior, and secure endpoint design.',
    path: '/docs/api/webhooks',
    category: 'API reference',
  },
  {
    title: 'SDK Guidance',
    description: 'Integration boundaries and language-level SDK expectations for implementation teams.',
    path: '/docs/integrations/sdk',
    category: 'Integrations',
  },
  {
    title: 'Banking Connectivity',
    description: 'Governed bank and wallet integration patterns for verification and financial workflows.',
    path: '/docs/products/banking-connectivity',
    category: 'Financial connectivity',
  },
  {
    title: 'Security Overview',
    description: 'Core control expectations for regulated identity, AML, and payout operations.',
    path: '/docs/security-compliance/security-overview',
    category: 'Security',
  },
  {
    title: 'AML Screening',
    description: 'Sanctions and watchlist workflows, review handling, and governance expectations.',
    path: '/docs/products/aml-screening',
    category: 'Compliance',
  },
  {
    title: 'System Overview',
    description: 'High-level platform model for Sentinel, Nexus, Horizon, and Orbit.',
    path: '/docs/architecture/system-overview',
    category: 'Architecture',
  },
];